import { Typography } from '@mui/material';
import React from 'react';
import Dashboard from 'types/entities/Dashboard';

const OtpCell = React.memo((row: Dashboard) => (
  <Typography noWrap variant="body2">
    {row.otp ?? ''}
  </Typography>
));

export default OtpCell;
